/**
 * Minimal stroke icon set (1.6px, currentColor). Editorial and quiet —
 * they read as engraved marks rather than app-store glyphs.
 */
const base = {
  width: 18,
  height: 18,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
}

export const IconHome = (p) => (
  <svg {...base} {...p}>
    <path d="M3 10.5 12 3l9 7.5" />
    <path d="M5 9.5V20a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V9.5" />
  </svg>
)

export const IconCommand = (p) => (
  <svg {...base} {...p}>
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </svg>
)

export const IconJourney = (p) => (
  <svg {...base} {...p}>
    <circle cx="5" cy="6" r="2" />
    <circle cx="19" cy="18" r="2" />
    <path d="M7 6h6a4 4 0 0 1 0 8H9a4 4 0 0 0 0 8" opacity=".9" />
  </svg>
)

// Reviews. A quote mark over a star: the two things a review can be — words
// SR owns outright, or a rating on somebody else's platform.
export const IconReviews = (p) => (
  <svg {...base} {...p}>
    <path d="M12 3.5l2.3 4.7 5.2.75-3.75 3.66.88 5.15L12 15.33 7.37 17.76l.88-5.15L4.5 8.95l5.2-.75z" />
  </svg>
)

export const IconPricing = (p) => (
  <svg {...base} {...p}>
    <path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0l-7.2-7.2a2 2 0 0 1-.6-1.4V4a1 1 0 0 1 1-1h7.9a2 2 0 0 1 1.4.6l7.5 7.5a2 2 0 0 1 0 2.3Z" />
    <circle cx="7.5" cy="7.5" r="1.2" />
  </svg>
)

export const IconArtwork = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="8" r="1.3" />
    <circle cx="8" cy="12" r="1.3" />
    <circle cx="16" cy="12" r="1.3" />
    <path d="M12 21a2.5 2.5 0 0 0 0-5 1.6 1.6 0 0 1 0-3" opacity=".9" />
  </svg>
)

export const IconBuilders = (p) => (
  <svg {...base} {...p}>
    <path d="M12 2 4 6v6c0 5 3.5 8 8 10 4.5-2 8-5 8-10V6Z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
)

export const IconTeam = (p) => (
  <svg {...base} {...p}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3 20a6 6 0 0 1 12 0" />
    <path d="M16.5 5.6a3.2 3.2 0 0 1 0 6.3" opacity=".9" />
    <path d="M17.5 14.2A6 6 0 0 1 21 20" opacity=".9" />
  </svg>
)

export const IconPresent = (p) => (
  <svg {...base} {...p}>
    <rect x="2.5" y="4" width="19" height="13" rx="1.6" />
    <path d="M12 17v4m-3.5 0h7" />
    <path d="m10.3 8.4 4.4 2.1-4.4 2.1Z" />
  </svg>
)

export const IconTopTier = (p) => (
  <svg {...base} {...p}>
    <path d="M3.4 7.8 7.3 11.4 12 4.3l4.7 7.1 3.9-3.6-1.6 11.4a.9.9 0 0 1-.9.8H5.9a.9.9 0 0 1-.9-.8Z" />
    <path d="M5.9 15.6h12.2" opacity=".5" />
  </svg>
)

/* AI Tools — a spark. Deliberately not a robot or a brain: these are sharpened
   instructions, not a machine that thinks for you. */
export const IconSpark = (p) => (
  <svg {...base} {...p}>
    <path d="M12 3.2 13.7 9l5.8 1.7-5.8 1.7L12 18.2l-1.7-5.8L4.5 10.7 10.3 9Z" />
    <path d="M18.4 3.4l.6 2 2 .6-2 .6-.6 2-.6-2-2-.6 2-.6Z" opacity=".55" />
  </svg>
)

export const IconLogout = (p) => (
  <svg {...base} {...p}>
    <path d="M15 4h3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3" />
    <path d="M10 12H3m0 0 3.5-3.5M3 12l3.5 3.5" />
  </svg>
)

export const IconSearch = (p) => (
  <svg {...base} {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.2-3.2" />
  </svg>
)

export const IconCheck = (p) => (
  <svg {...base} {...p}>
    <path d="m4 12 5 5L20 6" />
  </svg>
)

export const IconArrow = (p) => (
  <svg {...base} {...p}>
    <path d="M5 12h14m0 0-6-6m6 6-6 6" />
  </svg>
)
